class AgentModel {
    agentId?: number;
    categoryId?: number;
    categoryName?: string;
    agentCode?: string;
    firstName?: string;
    lastName?: string;
    genderId?: number;
    genderName?: string;
    nomineeName?: string;
    nomineeRelation?: string;
    aadharNumber?: string;
    aadharDocumentPath?: string;
    panNumber?: string;
    rationcardNumber?: string;
    communicationAddress?: string;
    email?: string;
    isMobileNumberVerifiedByAgent?: boolean; 

    address?: string;
    mobile?: string;
    alternateMobile?: string;
    pincode?: string;
    imagePath?: string;
    phone?: string;
    gstNumber?: string;

    bank?: string;
    branch?: string;
    ifscCode?: string;
    accountHolderName?: string;
    accountNumber?: string;
    isActive?: boolean;
    
}
export default AgentModel;